import { Col, Row } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

export const ShortageBanner = () => {
  const metaData = useSelector((state: any) => state.metaData);

  return (
    <Row className="justify-center mt-4">
      <Col className="full-width-content">
        <Row className="shortage-banner px-4 py-2 align-start">
          <ExclamationCircleOutlined className="mr-2" />
          <p className="my-0 text-md">
            Your impound account may have a shortage.&nbsp;
            <Link
              className="underline"
              to={`mailto:${metaData.companySupportEmail}`}
            >
              Contact us
            </Link>
            &nbsp; to resolve this issue.
          </p>
        </Row>
      </Col>
    </Row>
  );
};
